import { asyncActionType } from "utils/constants";

export const HEALTH_CHECK = asyncActionType("HEALTH_CHECK");
